import AccountantLayout from '../components/AccountantLayout';
import { EngineReviewLandingContent } from '../components/accountant/review/EngineReviewLandingContent';
import type { ReviewPanelMode } from '../types/engineReview';

interface Props { mode: ReviewPanelMode; }

export default function AccountantEngineReviewLanding({ mode }: Props) {
  const content = <EngineReviewLandingContent mode={mode} />;
  return mode === 'external' ? <AccountantLayout>{content}</AccountantLayout> : content;
}

